namespace TabAurous.Production {
    export namespace IssueMaterialItemsService {
        export const baseUrl = 'Production/IssueMaterialItems';

        export declare function Create(request: Serenity.SaveRequest<IssueMaterialItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IssueMaterialItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IssueMaterialItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IssueMaterialItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ParentMetalList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<IssueMaterialItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Production/IssueMaterialItems/Create",
            Update = "Production/IssueMaterialItems/Update",
            Delete = "Production/IssueMaterialItems/Delete",
            Retrieve = "Production/IssueMaterialItems/Retrieve",
            List = "Production/IssueMaterialItems/List",
            ParentMetalList = "Production/IssueMaterialItems/ParentMetalList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ParentMetalList'
        ].forEach(x => {
            (<any>IssueMaterialItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
